import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { useMemo } from 'react';

// Our Components
import Dropdown from 'components/Dropdown/Dropdown';

// List of States
import US_STATES from 'components/Dropdown/US_STATES.json';

// Our PropTypes
import CommonPropTypes from 'shared/prop-types';

function USStateDropdown({
	dropDownSX,
	dropDownLabelSX,
	helperText,
	state,
	setState,
	sx
}) {
	const US_STATE_LIST = useMemo(() => US_STATES, []);

	return (
		<Grid
			item
			xs={12}
			sm={11}
			md={5}
			lg={4}
			sx={{ marginLeft: 1, marginRight: 1, ...sx }}
		>
			<Dropdown
				helperText={helperText}
				items={US_STATE_LIST}
				label="State"
				labelSx={dropDownLabelSX}
				onChange={setState}
				placeholder="State"
				selected={state}
				sx={dropDownSX}
				variant="outlined"
			/>
		</Grid>
	);
}

USStateDropdown.propTypes = {
	dropDownLabelSX: CommonPropTypes.sx,
	dropDownSX: CommonPropTypes.sx,
	gridColumns: PropTypes.number,
	helperText: PropTypes.string,
	state: PropTypes.string.isRequired,
	setState: PropTypes.func.isRequired,
	sx: CommonPropTypes.sx
};

USStateDropdown.defaultProps = {
	dropDownLabelSX: {},
	dropDownSX: {},
	gridColumns: 5,
	helperText: '',
	sx: {}
};

export default USStateDropdown;
